<template>
  <div class="factory">
    <nav-header :navs="6" :navsitems="16"/>
    <div class="contents">
      <div class="in-banner">
        <img
            src="http://www.jiukaist.com/images/banner/8.png"
            width="100%"
            height="auto"
        />
      </div>
      <transition>
        <div class="pageBox waps">
          <el-tabs v-model="activeName">
            <el-tab-pane label="公司资讯" name="first">
              <div class="gsjs clearfix animation srcospcur" :loading="loading">
                <div class="Factorys-centers">
                  <div
                      class="Factorys-items"
                      v-for="(val, index) in company_information.datalist"
                      :key="index"
                  >
                    <div class="factory_item" :title="val.title" @click="goPages(val.id)">
                      <div style="width: 100%;height:  100%;overflow: hidden">
                        <el-image v-if="val.image.indexOf('http') != -1"
                                  :src="val.image"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[val.image]"
                        />
                        <el-image v-else
                                  :src="`http://www.jiukaist.com${val.image}`"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[val.image]"
                        />
                      </div>
                      <div class="layui-elip text">{{ val.title}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-pages">
                <el-pagination
                    background
                    @current-change="handleCurrent_Company_Information"
                    :current-page="company_information.page"
                    :page-size="company_information.pagesize"
                    layout="total,prev,pager,next"
                    :total="company_information.total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="行业资讯" name="second">
              <div class="gsjs clearfix animation srcospcur" :loading="loading">
                <div class="Factorys-centers">
                  <div
                      class="Factorys-items"
                      v-for="(val, index) in industry_information.datalist"
                      :key="index"
                  >
                    <div class="factory_item" :title="val.title" @click="goPages(val.id)">
                      <div style="width: 100%;height: 160px;overflow: hidden">
                        <el-image v-if="val.image.indexOf('http') != -1"
                                  :src="val.image"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[val.image]"
                        />
                        <el-image v-else
                                  :src="`http://www.jiukaist.com${val.image}`"
                                  style="width: 100%; height: auto"
                                  :preview-src-list="[val.image]"
                        />
                      </div>
                      <div class="layui-elip text">{{ val.title}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-pages">
                <el-pagination
                    background
                    @current-change="handleCurrent_Industry_Information"
                    :current-page="industry_information.page"
                    :page-size="industry_information.pagesize"
                    layout="total,prev,pager,next"
                    :total="industry_information.total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>

          </el-tabs>
        </div>
      </transition>
    </div>
    <nav-footer />
  </div>
</template>
<script>
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: "about",
  data() {
    return {
      loading:true,
      //公司资讯
      company_information:{
        page:1,
        pagesize:12,
        total:0,
        type:'19',
        datalist:[]
      },
      //行业资讯
      industry_information:{
        page:1,
        pagesize:12,
        total:0,
        type:'21',
        datalist:[]
      },
      activeName: 'first'
    };
  },
  components: {
    NavHeader,
    NavFooter,
  },
  mounted() {},
  created() {
    let self = this;
    document.documentElement.scrollTop='0px'
    self.getDataList(this.company_information);
    self.getDataList(this.industry_information);
  },
  methods: {
    handleCurrent_Company_Information(val) {
      this.company_information.page = val
      let self = this;
      self.getDataList(this.company_information);
    },
    handleCurrent_Industry_Information(val) {
      this.industry_information.page = val
      let self = this;
      self.getDataList(this.industry_information);
    },
    getDataList(param) {
      this.$api.mall
          .getNews({
            limit: param.pagesize,
            type:param.type,
            page: param.page,
          })
          .then((ress) => {
            let res = ress.data.data.data;
            param.datalist = res;
            param.total =  ress.data.data.total;
            self.loading = false
          });
    },
    goPages(id) {
      this.$router.push('/news/detail/'+id);
    },
  },
};
</script>
<style lang="scss" scoped>
.factory {
  width: 100%;
  overflow: hidden;
  margin: 0px auto;
  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }
  .v-enter-active {
    transition: all 1s ease;
  }
  .contents {
    width: 100%;
    min-width: 1350px;
    overflow: hidden;
    margin: 0px auto;
    padding-top: 75px;
    .el-pages{
      width: 100%;
      margin: 20px auto;
      overflow: hidden;
      text-align: center;
    }
    .waps {
      width: 90%;
      max-width: 1200px;
      overflow: hidden;
      margin: 0 auto;
    }
    .pageBox {
      padding: 60px 0;
      .Factorys-centers {
        width: 100%;
        margin: 0px auto;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        .Factorys-items {
          width: 31%;
          overflow: hidden;
          position: relative;
          height: 220px;
          margin-left: 25px;
          margin-bottom: 30px;
          box-sizing: border-box;
          box-shadow: 0 0 10px 0 #ddd;
          .factory_item{
            cursor: pointer;
            padding: 15px;
            width: calc(100% - 30px);
            height: calc(100% - 30px);
          }
          .text {
            position: absolute;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            bottom: 15px;
            width: calc(100% - 30px);
            left: 15px;
            height: 38px;
            color: #fff;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
            line-height: 38px;
          }
        }
      }
      .gsjs {
        transform: translate(0, 0px);
        opacity: 1;
        transition: 1.3s;
        -webkit-transition: 1.3s;
        .imgs {
          float: left;
          width: 420px;
          overflow: hidden;
        }
        .txts {
          float: right;
          width: calc(100% - 480px);
          line-height: 2em;
          font-family: 微软雅黑;
          font-size: 16px;
          color: #000000;
        }
        .txt {
          float: right;
          width: calc(100% - 480px);
          line-height: 1.5em;
        }
      }
      .pagetits {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3%;
        color: #333333;
      }

      .pagetit {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3.5%;
        color: #333333;
      }
    }
    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
    }
  }
  @media screen and(max-width:768px){
    .contents{
      padding-top: 60px!important;
      min-width: unset!important;
	  min-height: 600px;
    }
    .waps{
      width: calc(100% - 20px)!important;
      max-width: unset!important;
    }
    .pageBox{
      padding: 15px 0!important;
    }
    .Factorys-items{
      width: 46%!important;
      height: 140px!important;
      margin-left: 10px!important;
      margin-bottom:15px!important;
    }
    .factory_item{
      padding: 10px!important;
      width: calc(100% - 20px)!important;
      height: calc(100% - 20px)!important;
    }
    .text{
      width: calc(100% - 20px)!important;
      left: 10px!important;
    }
  }
}
</style>
